export const DocsRoutes = {
	Local: 'http://localhost:1700',
	LocalLive: 'http://localhost:1710',
	Cypress: 'http://localhost:1720',
	Test: 'https://docs.stage.agilox.net',
	Beta: 'https://docs.beta.agilox.net',
	Live: 'https://docs.agilox.net',
	Stage: 'https://docs.agilox.net',
} as const;
